module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp3-04-b80763738e82987acf7b3528c44f60ce.png";